import $ from "jquery";
window.$ = jQuery;
import "bootstrap";
import "./bootstrap";
import { tns } from "tiny-slider/src/tiny-slider";
window.tns = tns;
import "./global";
